/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Richtextlinkapply3Inputs */

const en_richtextlinkapply3 = /** @type {(inputs: Richtextlinkapply3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply`)
};

const de_richtextlinkapply3 = /** @type {(inputs: Richtextlinkapply3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übernehmen`)
};

/**
* | output |
* | --- |
* | "Apply" |
*
* @param {Richtextlinkapply3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const richtextlinkapply3 = /** @type {((inputs?: Richtextlinkapply3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Richtextlinkapply3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_richtextlinkapply3(inputs)
	return de_richtextlinkapply3(inputs)
});
export { richtextlinkapply3 as "richTextLinkApply" }